// Bulma Components
import { Card, Columns, Heading, Media, Image } from "react-bulma-components";

// Short-hand
const { Column } = Columns;

// Placeholder Components
// Used while actual data load
const CountryCard = (props) => {
    return (
        <Column size={props.size}>
            {/* Sample Data */}
            <Card>
                <Card.Image className="has-text-grey-lighter has-background-grey-lighter" size="16by9"/>
                <Card.Content>
                    <Media>
                    <Media.Item align="left" renderAs="figure">
                            <Image className="has-text-grey-lighter has-background-grey-lighter" size={32}/>
                        </Media.Item>
                        <Media.Item>
                            <Heading size={6} className="has-text-grey-lighter has-background-grey-lighter">
                                ASKJDSAKLDSAKJLDSAL
                            </Heading>
                        </Media.Item>
                    </Media>

                </Card.Content>
                <Card.Footer>
                    <Card.Footer.Item size={6}>
                        <span className="has-text-grey-lighter has-background-grey-lighter">
                            ASKJDS
                        </span>
                    </Card.Footer.Item>
                    <Card.Footer.Item size={6}>
                        <span className="has-text-grey-lighter has-background-grey-lighter">
                            ASKJDS
                        </span>
                        </Card.Footer.Item>
                    <Card.Footer.Item size={6}>
                        <span className="has-text-grey-lighter has-background-grey-lighter">
                            ASKJDS
                        </span>
                        </Card.Footer.Item>
                </Card.Footer>
            </Card>
        </Column>
    );
};

export default CountryCard;